import {useSelector} from 'react-redux';
import Selector from '../../../selectors/modals/facebook';

import HasProfile from './has-profile';
import NoProfile from './no-profile';

export default () => {
    const {profile} = useSelector(Selector);

    return (
        <div className="modal auth facebook animate__animated animate__fadeInUp animate__faster ">
            {
                profile
                ? <HasProfile />
                : <NoProfile />
            }
        </div>
    )
}